import React from 'react';

import { Link } from 'gatsby';
import Video from '@media-spec/core/src/components/Video/';
import Header from '@media-spec/core/src/components/Header/index';
import { Wrapper } from '@media-spec/core/src/components/Wrapper/Wrapper';
import TextHeader from '@media-spec/core/src/components/TextHeader';
import TextComponent from '@media-spec/core/src/components/TextComponent';
import { peopleList } from '@utils/staticText';
import classnames from 'classnames';

import { Pages } from '@containers/Pages/Pages';
import { Quote } from '@components/Quote/Quote';

import * as commonClass from '@styles/common.module.css';
import * as S from '@containers/Person/Person.module.css';

import MainLogo from '@images/header_logo.svg';
import BackIcon from '@images/back_icon.svg';

import { useScroll } from '@root/hooks/useScroll/useScroll';

export const Person: React.FunctionComponent<IPersonProps> = ({
  pageContext: { id },
}) => {
  const currentId = Number(id) || 0;
  const personId =
    currentId > peopleList.length - 1 ? peopleList.length - 1 : currentId;
  const { title, quotes, videoId, bigAvatar, about } = peopleList[
    personId
  ] as IPerson;
  const scrollY = useScroll();
  return (
    <Pages personId={personId}>
      <Header
        MainLogo={MainLogo}
        MainLogoTouch={MainLogo}
        bgColor="#fff"
        burgerColor="#005FF9"
        bgClassName={S.header}
        className={S.headerContainer}
        logoWrapperClassName={classnames(
          S.logoWrapper,
          scrollY > 0 ? commonClass.headerShadow : ''
        )}
      />
      <Wrapper paddingTop={false}>
        <div className={classnames(commonClass.marginBottom40, S.titleWrapper)}>
          <Link to="/#personsId" className={S.backIcon}>
            <BackIcon />
          </Link>
          <TextHeader className={commonClass.title}>{title}</TextHeader>
        </div>
        <img alt={title} className={S.PersonAvatar} src={bigAvatar} />
        {quotes.map((quote, index) => (
          <Quote key={index} text={quote} />
        ))}
        <Video
          ratio={16 / 9}
          src={`https://player-smotri.mail.ru?viewMode=external&brandsafety=0&channel=news&startId=${videoId}&noSound=1&place_id=article&autoplay=1&streamId=mediaproject_in_article_news`}
          className={commonClass.marginBottom40}
        />
        <TextComponent className={S.about} content={[about]} />
      </Wrapper>
    </Pages>
  );
};
